/**
 * Get the route path for a unified conversation based on its type.
 */
import type { UnifiedConversation } from "../types/unified-chat.types"

export function getConversationRoute(conversation: UnifiedConversation): string {
  switch (conversation.type) {
    case "ai":
      return `/chats/ai/${conversation.id}`
    case "dm":
      return `/chats/dm/${conversation.id}`
    case "ritual-group":
      return `/chats/ritual/${conversation.id}`
    default:
      return "/chats"
  }
}
